
function showNew(){
  $('.account__address .customer__form').slideUp()
  if ($('.account__add-address').hasClass('active')) {
    $('.account__add-address').removeClass('active')
    $('#address_form_new').slideUp()
  } else {
    $('.account__add-address').addClass('active')
    $('#address_form_new').slideDown()
  }
}

function cancelForm (){
  if ($('.account__add-address').hasClass('active')) {
    $('#address_form_new').slideUp()
    $('.account__add-address').removeClass('active')
  }
  if ($('.account__address').hasClass('active')) {
    $('.account__address .customer__form').slideUp()
    $('.account__address').removeClass('active')
  }
}


function showEdit (id) {
  if ($('.account__add-address').hasClass('active')) {
    $('.account__add-address').removeClass('active')
    $('#address_form_new').slideUp()
  }
  if ($(`.account__address:not([data-id=${id}])`).hasClass('active')) {
    $('.account__address.active .customer__form').slideUp()
    $('.account__address').removeClass('active')
  }
  if ($(`.account__address[data-id=${id}]`).hasClass('active')) {
    $(`.account__address[data-id=${id}] .customer__form`).slideUp()
    $(`.account__address[data-id=${id}]`).removeClass('active')

  }else {
    $(`.account__address[data-id=${id}] .customer__form`).slideDown()
    $(`.account__address[data-id=${id}]`).addClass('active')
  }
}


const customer = {
  init: () => {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {hideElement: 'AddressProvinceContainerNew'});

    let addresses = document.querySelectorAll('.account__address')

    addresses.forEach(address => {
      let id = address.dataset.id
      new Shopify.CountryProvinceSelector(`AddressCountry_${id}`, `AddressProvince_${id}`, {hideElement: `AddressProvinceContainer_${id}`});
    })

    let edit_buttons = document.querySelectorAll('.edit')
    edit_buttons.forEach(button => {
      let id = button.dataset.id
      button.addEventListener('click', () => {
        showEdit(id)
      })
    });

    $('.cancel').click(cancelForm)
    $('#add_new_address .add').click(showNew)
  }
};

customer.init()
